import Swal from "sweetalert2";

export const capitalizeFirstLetter = (string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const Logout = () => {
    localStorage.removeItem("zubrus_user_data");
    localStorage.removeItem("persist:root");
    window.location.reload()
}

export const convertTo12HourFormat = (time) => {
    const [hour, minute] = time.split(':').map(Number);
    const period = hour >= 12 ? 'PM' : 'AM';
    const formattedHour = hour % 12 || 12;
    return `${formattedHour}:${minute.toString().padStart(2, '0')} ${period}`;
}

export const formatDate = (isoString) => {
    if (!isoString) return "N/A";

    const dateObj = new Date(isoString);
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();

    return `${day}/${month}/${year}`;
};

export const generateRandomId = () => {
    const timestamp = Date.now().toString(36);
    console.log('timestamp :>> ', timestamp);
    const randomStr = Math.random().toString(36).substring(2, 8);
    return `${timestamp}-${randomStr}`;
};

export const formatTextWithNewlines = (text) => {
    if (!text) return '';

    // Handle HTML content
    if (text.includes('<') && text.includes('>')) {
        return text.replace(/\n/g, '<br />');
    }

    // Handle special characters and formatting
    let formattedText = text
        .replace(/\n/g, '<br />') // Newlines
        .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;') // Tabs
        .replace(/ {2}/g, '&nbsp;&nbsp;') // Double spaces
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') // Bold
        .replace(/\*(.*?)\*/g, '<em>$1</em>') // Italic
        .replace(/_(.*?)_/g, '<u>$1</u>') // Underline
        .replace(/~~(.*?)~~/g, '<s>$1</s>') // Strikethrough
        .replace(/`(.*?)`/g, '<code>$1</code>') // Inline code
        .replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'); // Links

    return formattedText;
};

/**
 * Displays confirmation popup for removing an item.
 *
 * @param {Object} params - The parameters for the alert popup.
 * @param {Function} params.t - (required) useTranslation function (e.g., from i18next) for localization support.
 * @param {Function} params.preConfirm - (required) A callback function executed before confirming the alert.
 * @param {string} params.title - The title displayed in the alert popup.
 * @param {string} params.confirmText - The text displayed on the confirm button.
 * @param {string} params.name - The name of the item to be removed (used in the alert body).
 *
 * @example
 * removeAlertPopup({
 *   preConfirm: handleRemove,
 *   title: 'Are you sure?',
 *   confirmText: 'Yes, delete it!',
 *   name: 'UserName',
 *   t: t, // useTransition() mock translation
 * });
 */
export const removeAlertPopup = ({ preConfirm, title, confirmText, name, t }) => {
    Swal.fire({
        icon: "question",
        title: title || (name ? `${t("areYouSureYouWantToDelete")} ${name}?` : t("areYouSureYouWantToDelete")),
        showCancelButton: true,
        confirmButtonText: confirmText || t("Delete"),
        cancelButtonText: t("Cancel"),
        customClass: {
            title: "text-xl",
            confirmButton: "bg-red-500 hover:bg-red-600",
            cancelButton: "bg-transparent hover:bg-gray-200 text-black"
        },
        showLoaderOnConfirm: true,
        preConfirm
    })
}

export const getSelectedSchoolId = () => {
  try {
    const userData = JSON.parse(localStorage.getItem("zubrus_user_data"));
    return userData?.selectedSchoolId || "683dffd95e687809fbc73350";
  } catch (error) {
    return "683dffd95e687809fbc73350";
  }
};

export const getSelectedSchool = () => {
  try {
    const userData = JSON.parse(localStorage.getItem("zubrus_user_data"));
    return userData?.selectedSchool || null;
  } catch (error) {
    console.error("Error getting selected school:", error);
    return null;
  }
};

// New Redux-based functions
export const getSelectedSchoolFromRedux = (state) => {
  return state.schoolData.selectedSchool;
};

export const getSelectedSchoolIdFromRedux = (state) => {
  return state.schoolData.selectedSchool?.id || null;
};